export const PAYMENT_PROVIDER = {
    Stripe: 1,
    PayConnexion: 2,
    EzPay: 3,
    Paymentus: 4
};

export const CHARGE_STATUS = {
    Draft: -1,
    Succeeded: 1,
    Failed: 2,
    Refunded: 3,
    ExternalProcessing: 4,
    CancelledByUser: 5,
    ManualRefund: 6,
    ManualSuccess: 7,
    ReconciliationNeeded: 8,
    OutsidePending: 9,
    OutsideSuccess: 10,
    OutsideRefund: 11,
    OutsideFailed: 12,
    Pending: 13,
    Chargeback: 14,
    ChargebackReversed: 15,
    PartialRefund: 16
};

export function statusDisplayClass(status) {
    switch (status) {
        case CHARGE_STATUS.Failed:
        case CHARGE_STATUS.Abandoned:
        case CHARGE_STATUS.OutsideFailed:
        case CHARGE_STATUS.CancelledByUser:
        case CHARGE_STATUS.Chargeback:
            return "text-bubble-danger";
        case CHARGE_STATUS.Succeeded:
        case CHARGE_STATUS.ManualSuccess:
        case CHARGE_STATUS.OutsideSuccess:
        case CHARGE_STATUS.ChargebackReversed:
            return "text-bubble-success";
        default:
            return "text-bubble-info";
    }
}

/**
 * Based on charge status and the available transitions for the payment
 * adapter, determine whether there's a possible manual status change for
 * the status of this charge
 * @param {*} charge
 * @param {*} adapterOptions
 */
export function canChangeStatusForCharge(charge, adapterOptions) {
    const transitionsForThisStatus = adapterOptions.StatusTransitionList.find((transitionList) => {
        return transitionList.EditableStatus === charge.Status;
    });
    return transitionsForThisStatus && transitionsForThisStatus.AllowedTargetStatuses.length > 0;
}
